module.exports = __webpack_public_path__ + "img/8b16746.png";